import React from 'react';

import { SETUP_PREFIX_PATH } from 'constants/route.constant';
import {
	ROOT,
	ADMIN,
	CONTRACTOR,
	PROVIDER,
	USER,
} from 'constants/roles.constant';

const setupRoute = [
	{
		key: 'setup.welcome',
		path: `${SETUP_PREFIX_PATH}/welcome`,
		component: React.lazy(() => import('views/setup/Welcome')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
		approved: false,
		meta: {
			pageContainerType: 'default',
			footer: true,
		},
	},
	{
		key: 'setup.kycForm',
		path: `${SETUP_PREFIX_PATH}/kyc-start`,
		component: React.lazy(() => import('views/setup/KycForm')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
		approved: false,
		meta: {
			pageContainerType: 'default',
			footer: true,
		},
	},
];

export default setupRoute;
